module.exports = __webpack_public_path__ + "static/media/dhl.c77f9fdc.svg";